import { render } from "./assets-details.vue?vue&type=template&id=ba346ff4"
import script from "./assets-details.vue?vue&type=script&lang=js"
export * from "./assets-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__